const ResourceAccess = {
  NULLENUM: 0,
  HAS_ACCESS: 100,
  NOT_AUTHENTICATED: 200,
  INSUFFICIENT_PRIVILEGE: 300,
  NO_ACCESS: 400,
  INACTIVE_SUB: 500,
};
// eslint-disable-next-line import/prefer-default-export
export { ResourceAccess };
